import i18n from 'config/i18n';
import * as yup from 'yup';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale());

const schema = yup.object({
  name: yup.string().required(
    t('validationFieldRequired', {
      name: t('adminPortal.declarationTypes.name')
    })
  ),
  isDefault: yup.boolean().required(),
  validFrom: yup.date().required(
    t('validationFieldRequired', {
      name: t('adminPortal.declarationTypes.validFrom')
    })
  ),
  validTo: yup
    .date()
    .required(
      t('validationFieldRequired', {
        name: t('adminPortal.declarationTypes.validTo')
      })
    )
    .min(yup.ref('validFrom'), t('validationStartAndEndDateDifference'))
});

export default schema;
